module.exports = __webpack_public_path__ + "static/media/map.8d277552.jpg";